import { Box, Link } from '@chakra-ui/core';
import { generateMnemonic } from 'bip39';
import React, { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Route, Switch, useLocation } from 'react-router-dom';
import './App.css';
import BackgroundServices from './components/BackgroundServices';
import SignIn from './components/RestoreFlow';
import CounterViewOfferContainer from './containers/CounterViewOffer';
import Enter from './containers/Enter';
import NewBet from './containers/NewBet';
import NotificationDashboard from './containers/NotificationDashboard';
import SetupInfluencer from './containers/SetupInfluencer';
import TotalPayout from './containers/TotalPayout';
import UserBets from './containers/UserBets';
import ViewBet from './containers/ViewBet';
import ViewInfluencerBets from './containers/ViewInfluencerBets';
import { useAppDispatch } from './store';
import { setMnemonic } from './store/wallet/walletSlice';
import keystore from './utils/Keystore';
function App() {
  const location = useLocation();
  // const mnemonic = useSelector((state: RootState) => state.wallet.mnemonic);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const storedMnemonic = keystore.get('mnemonic');
    const encryptedMnemonic = window.localStorage.getItem('encryptedMnemonic');

    if (storedMnemonic) {
      dispatch(setMnemonic(storedMnemonic));
    } else if (!encryptedMnemonic) {
      dispatch(setMnemonic(generateMnemonic(128)));
    }
  }, [dispatch]);

  // Reload page if idled for too
  const handleOnIdle = () => {
    window.location.reload();
  };

  useIdleTimer({
    timeout: 1000 * 60 * 60,
    onIdle: handleOnIdle,
  });

  return (
    <>
      <BackgroundServices />
      <Box
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        textDecor="underline"
        h="30px"
        color="white"
        w="full"
        fontSize="sm"
        bg="#27ae60"
      >
        <Link
          href="https://twitter.com/AtomicFinance"
          target="_blank"
        >
          <b>
            <u>UPDATE:</u>
          </b>
          &nbsp; Election bets are now resolved. You can withdraw your winnings.
        </Link>
      </Box>

      <Box height="100%" width="fit-content" minW="100%" bg="#edeef0">
        {/* <TransitionGroup exit={false} width="100%" component={null}> */}
        {/* <CSSTransition key={location.key} timeout={300} classNames="fade"> */}
        <Switch location={location}>
          <Route exact path="/">
            <Enter />
          </Route>
          <Route exact path="/new">
            <NewBet />
          </Route>
          <Route path="/offer/:contractUUID">
            <CounterViewOfferContainer />
          </Route>
          <Route path="/bet/:contractUUID">
            <ViewBet />
          </Route>

          <Route path="/setup-influencer/:referralCode">
            <SetupInfluencer />
          </Route>
          <Route path="/offers/:twitterScreenName">
            <ViewInfluencerBets />
          </Route>
          <Route path="/influencer/:twitterScreenName">
            <ViewInfluencerBets />
          </Route>

          <Route path="/dashboard">
            <UserBets />
          </Route>
          <Route path="/notification-dashboard">
            <NotificationDashboard />
          </Route>
          <Route path="/payout">
            <TotalPayout />
          </Route>
          <Route path="/enter">
            <Enter />
          </Route>
          <Route path="/recover">
            <SignIn />
          </Route>
        </Switch>
        {/* </CSSTransition> */}
        {/* </TransitionGroup> */}

        {/* <Container>Heya1</Container> */}
      </Box>
    </>
  );
}

export default App;
